import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { ReactComponent as CloseIcon } from '$icons/uncolored/Close.svg';
import { ReactComponent as ArrowRight } from '$icons/ArrowRight.svg';
import { tracker } from '$utils/tracker';

import {
  candidatesApi,
  useUpdateCandidatePositionStatusToOfferSentMutation,
} from '../../../../../../store/modules/candidates';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks';
import { companiesApi } from '../../../../../../store/modules/companies';

type Props = {
  handleClose: (show: boolean) => void;
  candidatePositionStatusId: number;
  candidateId: number;
};

const MakeOfferConfirmModalContent: FC<Props> = ({
  handleClose,
  candidatePositionStatusId,
  candidateId,
}) => {
  const [t, i18n] = useTranslation('global');
  const { serverUser } = useAppSelector((state: any) => state.auth);
  const [updateCandidatePositionStatusToOfferSentAsCandidate] =
    useUpdateCandidatePositionStatusToOfferSentMutation();
  const dispatch = useAppDispatch();

  const handleConfirm = async () => {
    await updateCandidatePositionStatusToOfferSentAsCandidate({
      data: {
        candidatePositionStatusId,
        user: {
          name: `${serverUser?.FirstName} ${serverUser?.LastName}`,
          email: serverUser?.Email!,
        },
      },
      lang: i18n.language as 'en' | 'es',
    }).then(() => {
      dispatch(candidatesApi.util.invalidateTags(['Candidates']));
      dispatch(companiesApi.util.invalidateTags(['PositionsList']));
      tracker.emit('Make Offer', {
        candidate_id: candidateId,
      });
      handleClose(false);
    });
  };

  return (
    <div className="flex flex-col gap-4 bg-white p-8 rounded-xl font-mulish w-[calc(100%-40px)] sm:w-[600px]">
      <button
        type="button"
        className="text-spk-mediumContrast text-sm items-center flex flex-row justify-end ml-auto"
        onClick={() => handleClose(false)}
      >
        Close
        <CloseIcon className="stroke-spk-mediumContrast w-4 h-4" />
      </button>
      <div className="flex flex-col justify-between items-start gap-2 border-b-[1px] border-[#E6F0F4] pb-4">
        <h1 className="text-2xl font-extrabold">
          {t('MakeOfferConfirmModal.ConfirmTitle')}
        </h1>
      </div>
      <div className="items-center flex flex-col gap-8 w-full">
        <p className="text-spk-mediumContrast w-full text-center sm:text-start">
          {t('MakeOfferConfirmModal.ComfirmText')}
        </p>
        <div className="flex gap-4 justify-end w-full flex-col-reverse sm:flex-row">
          <Button
            type="button"
            severity="success"
            text
            label={t('MakeOfferConfirmModal.ConfirmBack')}
            onClick={() => handleClose(false)}
          />
          <Button
            type="button"
            severity="success"
            className="flex gap-2"
            onClick={handleConfirm}
          >
            <span>{t('MakeOfferConfirmModal.ConfirmButton')}</span>
            <ArrowRight className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MakeOfferConfirmModalContent;
